export default __webpack_public_path__ + "static/media/Magic_Site_Logo.783f08a5.png";